import { render } from "./EditBasicDetails.vue?vue&type=template&id=288725e4"
import script from "./EditBasicDetails.vue?vue&type=script&lang=js"
export * from "./EditBasicDetails.vue?vue&type=script&lang=js"

import "./EditBasicDetails.vue?vue&type=style&index=0&id=288725e4&lang=css"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__